import { render, staticRenderFns } from "./cardBalanceAssets.vue?vue&type=template&id=71e742a6&scoped=true&"
import script from "./cardBalanceAssets.vue?vue&type=script&lang=js&"
export * from "./cardBalanceAssets.vue?vue&type=script&lang=js&"
import style0 from "./cardBalanceAssets.vue?vue&type=style&index=0&id=71e742a6&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e742a6",
  null
  
)

export default component.exports